import { PlatformKey } from 'platform-config'

export const DownloadIcon = defineComponent({
  setup() {
    return () =>
      PlatformKey === 'bge' ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15" fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.03173 8L9.93559 5.70571C10.3177 5.3037 10.937 5.3037 11.3191 5.70571C11.7011 6.108 11.7011 6.76011 11.3191 7.16239L6.78276 10.9582C6.59949 11.1516 6.35052 11.2602 6.09099 11.2598C6.08315 11.2598 6.07539 11.2593 6.06762 11.2588C6.06291 11.2585 6.0582 11.2582 6.05345 11.258C6.04871 11.2582 6.04399 11.2585 6.03929 11.2588C6.03151 11.2593 6.02376 11.2598 6.01591 11.2598C5.75639 11.2602 5.50743 11.1516 5.32414 10.9582L0.787769 7.16239C0.405756 6.76011 0.405756 6.108 0.787769 5.70571C1.1699 5.3037 1.78917 5.3037 2.1713 5.70571L5.07517 8V1.01376C5.08352 0.457629 5.50973 0.00892294 6.03798 0.000131379C6.57827 -0.0088616 7.02319 0.444955 7.03173 1.01375V8ZM0.000109239 13.9538C-0.00736672 14.5226 0.36982 14.991 0.842578 15H11.1439C11.6167 15 11.9999 14.5388 11.9999 13.97C11.9999 13.4012 11.6166 12.9401 11.1438 12.9402H0.842578C0.380357 12.949 0.00741782 13.3977 0.000109239 13.9538Z"
            fill="white"
          />
        </svg>
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15" fill="none" style={{ cursor: 'pointer' }}>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.03173 8L9.93559 5.70571C10.3177 5.3037 10.937 5.3037 11.3191 5.70571C11.7011 6.108 11.7011 6.76011 11.3191 7.16239L6.78276 10.9582C6.59949 11.1516 6.35052 11.2602 6.09099 11.2598C6.08315 11.2598 6.07539 11.2593 6.06762 11.2588C6.06291 11.2585 6.0582 11.2582 6.05345 11.258C6.04871 11.2582 6.04399 11.2585 6.03929 11.2588C6.03151 11.2593 6.02376 11.2598 6.01591 11.2598C5.75639 11.2602 5.50743 11.1516 5.32414 10.9582L0.787769 7.16239C0.405756 6.76011 0.405756 6.108 0.787769 5.70571C1.1699 5.3037 1.78917 5.3037 2.1713 5.70571L5.07517 8V1.01376C5.08352 0.457629 5.50973 0.00892294 6.03798 0.000131379C6.57827 -0.0088616 7.02319 0.444955 7.03173 1.01375V8ZM0.000109239 13.9538C-0.00736672 14.5226 0.36982 14.991 0.842578 15H11.1439C11.6167 15 11.9999 14.5388 11.9999 13.97C11.9999 13.4012 11.6166 12.9401 11.1438 12.9402H0.842578C0.380357 12.949 0.00741782 13.3977 0.000109239 13.9538Z"
            fill="var(--colors-text-base)"
          />
        </svg>
      )
  },
})

export const PhoneDownloadIcon = defineComponent({
  setup() {
    return () => (
      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_130757_208663" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="3" y="3" width="18" height="19">
          <g clip-path="url(#clip0_130757_208663)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.753 5.375V14.0615L15.9697 10.844L17.0303 11.9052L12.5302 16.4053L12 16.9355L11.4698 16.4053L6.96975 11.9052L8.03025 10.8448L11.253 14.0675V5.375H12.753ZM17.25 19.625V18.125H6.75V19.625H17.25Z"
              fill="var(--colors-bg-icon-primary)"
            />
          </g>
        </mask>
        <g mask="url(#mask0_130757_208663)">
          <rect x="3" y="3.5" width="18" height="18" fill="var(--colors-bg-icon-primary)" />
        </g>
        <defs>
          <clipPath id="clip0_130757_208663">
            <rect width="18" height="18" fill="var(--colors-bg-icon-primary)" transform="translate(3 3.5)" />
          </clipPath>
        </defs>
      </svg>
    )
  },
})
